import { useState } from 'react';

import DragAndDropFiles from './DragAndDropFiles';

import classes from './DropFilesHidden.module.css'

const DropFilesHidden = ({children, uploadfile}) => {

    const [showdropFiles, setShowDropFiles] = useState(false)

    let dragTimer;
    function dragOverHandler(e) {
        var dt = e.dataTransfer;
        if (dt.types && (dt.types.indexOf ? dt.types.indexOf('Files') !== -1 : dt.types.contains('Files'))) {
            setShowDropFiles(true)
            window.clearTimeout(dragTimer);
        }
    }

    function dragLeaveHandler() {
        dragTimer = window.setTimeout(function() {
            setShowDropFiles(false)
        }, 100);
    }

    function removeFilesHandler() {
        setShowDropFiles(false)
    }

    return <div className={classes.container} onDragOver={dragOverHandler} onDragLeave={dragLeaveHandler}>
        <div className={classes.container_inner}>
            {children}
        </div>
        {showdropFiles && <DragAndDropFiles removeFiles={removeFilesHandler} uploadfile={uploadfile}/>}
    </div>
}

export default DropFilesHidden